import React from "react";
import PropTypes from "prop-types";

export default function Dots(props) {
  return (
    <svg
      width="18"
      height="4"
      viewBox="0 0 18 4"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2 2H2.01M9 2H9.01M16 2H16.01M3 2C3 2.55228 2.55228 3 2 3C1.44772 3 1 2.55228 1 2C1 1.44772 1.44772 1 2 1C2.55228 1 3 1.44772 3 2ZM10 2C10 2.55228 9.55228 3 9 3C8.44772 3 8 2.55228 8 2C8 1.44772 8.44772 1 9 1C9.55228 1 10 1.44772 10 2ZM17 2C17 2.55228 16.5523 3 16 3C15.4477 3 15 2.55228 15 2C15 1.44772 15.4477 1 16 1C16.5523 1 17 1.44772 17 2Z"
        stroke="#063AC9"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>

    // <svg
    //     className={props.className}
    //     width={props.width}
    //     height={props.height}
    //     viewBox={`0 0 ${props.width} ${props.height}`}
    //     fill="none"
    //     xmlns="http://www.w3.org/2000/svg"
    //   >
    //     <circle
    //       cx="19.6954"
    //       cy="1.99987"
    //       r="1.73913"
    //       transform="rotate(90 19.6954 1.99987)"
    //       fill={props.fill}
    //     />
    //     <circle
    //       cx="11.0001"
    //       cy="1.99987"
    //       r="1.73913"
    //       transform="rotate(90 11.0001 1.99987)"
    //       fill={props.fill}
    //     />
    //     <circle
    //       cx="2.30481"
    //       cy="1.99987"
    //       r="1.73913"
    //       transform="rotate(90 2.30481 1.99987)"
    //       fill={props.fill}
    //     />
    //   </svg>
  );
}

Dots.propTypes = {
  className: PropTypes.string,
  fill: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number
};
Dots.defaultProps = {
  className: "",
  fill: "#063AC9",
  width: 22,
  height: 4
};
